<template>
    <div>
        <Breadcumb :title="article.title" :breadcumb-data="breadcumbData">
        </Breadcumb>
        <b-card class="mb-4 cardcontainer" footer-class="pt-0 px-0 pb-3">
            <div class="media flex-wrap align-items-center" slot="header">
                <div class="media-body ml-3">
                    <a href="javascript:void(0)">{{article.author.firstname}} {{article.author.lastname}} </a>
                    <div class="text-muted small">{{article.date_created|formatDate}}</div>
                </div>
            </div>
            
            <div v-html="article.content"></div>
            
            <div slot="footer" class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="px-4 pt-3">
                    <a href="javascript:void(0)" class="text-muted">
                        <i class="ion ion-ios-heart-empty text-danger text-large align-middle"></i>&nbsp;
                        <span class="align-middle">Nombre de Like}</span>
                    </a>
                    <span class="text-muted ml-4">
          </span>
                </div>
                <div class="px-4 pt-3">
                    <b-btn variant="primary"><i class="ion ion-md-create"></i>&nbsp; Répondre</b-btn>
                </div>
            </div>
        </b-card>
        <b-card class="mb-3">
            <b-form-group label="Votre commentaire" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                <b-textarea placeholder="Votre commentaire" :rows="5" v-model="comment"/>
            </b-form-group>
            <b-btn v-on:click="addComment" variant="primary"><i class="ion ion-md-create"></i>&nbsp; Répondre</b-btn>
        </b-card>
        <div v-for="comment in article.comments" :key="comment.author.id">
            <b-card class="mb-3">
                
                <div class="media">
                    <div class="media-body ml-4">
                        <div class="float-right text-muted small">{{comment.date_created|formatDate}}</div>
                        <a href="javascript:void(0)">{{comment.author.firstname}} {{comment.author.lastname}}</a>
                        <div class="mt-2" v-html="comment.content"></div>
                    </div>
                </div>
            
            </b-card>
        </div>
    
    </div>
</template>

<script>
    import * as numeral from 'numeral'
    import {ADD_COMMENT_REQUEST, GET_FORUMARTICLE_REQUEST} from "../_store/exchange/actiontypes";
    import Breadcumb from '../components/breadcumb'
    import { mapState } from 'vuex';

    export default {
        name: 'pages-forums-discussion',
        components: { Breadcumb},
        computed: mapState({ article: state => state.exchange.article}),
        data() {
            return {
                breadcumbData: [],
                comment: '',
            }
        },
        methods: {
            addComment: function(e) {
                e.preventDefault()
                this.$store.dispatch(ADD_COMMENT_REQUEST, {
                    article: this.$route.params.id,
                    content: this.comment
                })
                    .then(() => {
                        this.$router.push("/echanges/article/" + this.$route.params.id + "/");
                        this.$store.dispatch(GET_FORUMARTICLE_REQUEST, this.$route.params.id);
                        this.comment = '';
                    })
            }
        },
        mounted () {
            this.$store.dispatch(GET_FORUMARTICLE_REQUEST, this.$route.params.id)
                .then(() => {
                    this.breadcumbData = [
                        {text: this.$t('welcome'), href: '/dashboard/'},
                        {text: "Forum d'échange", href: '/echange/forum/'},
                        {text: this.article.category.name, href: '/echange/forum/' + this.article.category.id},
                        {text: this.article.title, active:true}
                    ];
                    console.log(this.breadcumbData)
                })
        }
    }
</script>
